<template>
  <div class="page">
    <AppHeader />
    <OneOffer :lead="lead" />
    <PersonalAgent />
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import OneOffer from './GeneralContainer/OneOffer/OneOffer.vue'
import PersonalAgent from './GeneralContainer/PersonalAgent.vue'

export default {
  name: 'PrintVersion',
  props: {
    lead: {
      type: Object,
      required: true,
    },
  },
  components: {
    AppHeader,
    OneOffer,
    PersonalAgent,
  },
}
</script>

<style scoped>
.page {
  page-break-after: always;
  padding-top: 2px;
}
</style>